import ReactDOM from 'react-dom';

import { useAuthentication } from '~/data/user/useAuthentication';
import {
  DispatchReduxFetch,
  useInitializeCommonReduxData,
} from '~/hooks/initializeData';
import { LibraryComponentProviders } from '~/library/components/LibraryComponentProviders';
import { Providers } from '~/Providers';
import { EmployeeActivityLogDialog } from '~/scenes/PeopleModule/components/EmployeeActions/EmployeeActivityLogDialog';
import { EmployeeActivityLogDialogProps } from '~/scenes/PeopleModule/components/EmployeeActions/EmployeeActivityLogDialog/component';

export const UserActivityLogDialogComponent = (
  props: EmployeeActivityLogDialogProps,
) => {
  const { isAuthenticated } = useAuthentication();

  const {
    requiredStatus: { isInitializing },
  } = useInitializeCommonReduxData({
    required: [
      DispatchReduxFetch.ApplicationConfig,
      DispatchReduxFetch.AllEnums,
      DispatchReduxFetch.Languages,
      DispatchReduxFetch.AllEmployees,
      DispatchReduxFetch.AllOrgUnits,
    ],
  });

  if (!isAuthenticated || isInitializing) {
    return null;
  }

  return (
    <LibraryComponentProviders>
      <EmployeeActivityLogDialog {...props} />
    </LibraryComponentProviders>
  );
};

export const renderUserActivityLogDialogComponent = (
  containerId: string,
  props: EmployeeActivityLogDialogProps,
) => {
  ReactDOM.render(
    <Providers>
      <UserActivityLogDialogComponent {...props} />
    </Providers>,
    document.getElementById(containerId),
  );
};
